import { useState } from 'react';
import AppLayout from '@amzn/awsui-components-react/polaris/app-layout';
import ContentLayout from "@amzn/awsui-components-console/content-layout";
import Container from "@amzn/awsui-components-console/container";
import { Header } from '@amzn/awsui-components-react';

import NavigationBreadcrumbs from "../../common/navigation/NavigationBreadcrumbs";
import SideNavigationMenu from '../../common/navigation/SideNavigationMenu';
import ChatbotContent from '../../components/ChatbotWidget/ChatbotContent';
import Paths from "../../common/paths/paths";
import { getString } from '../../common/ui-string-labels/ui-strings-utils';

const breadcrumbs = {
    items:
    [
        { text: Paths.Admin.name, href: Paths.manageOrders.url },
        { text: Paths.chatbot.name, href: Paths.chatbot.url }
    ]
}

const ChatbotPage = () => {
    const [navigationOpen, setNavigationOpen] = useState(false);

    return (
        <AppLayout
            headerSelector="#top-nav"
            toolsHide={true}
            content={
                <ContentLayout header={<Header variant="h1">{getString('chatbot.drawer.header')}</Header>}>
                    <Container>
                        <ChatbotContent variant="page" />
                    </Container>
                </ContentLayout>
            }
            breadcrumbs={<NavigationBreadcrumbs items={breadcrumbs.items} />}
            navigation={<SideNavigationMenu />}
            navigationOpen={navigationOpen}
            onNavigationChange={({ detail }) => setNavigationOpen(detail.open)}
        />
    );
}

export default ChatbotPage;